var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.666 6.333a1.249 1.249 0 00-1.768 0l-3.722 3.722a.25.25 0 01-.353 0L8.1 6.333A1.25 1.25 0 106.333 8.1l3.722 3.722a.251.251 0 010 .354L6.333 15.9a1.25 1.25 0 000 1.768 1.27 1.27 0 001.768 0l3.722-3.722a.248.248 0 01.353 0l3.724 3.72a1.272 1.272 0 001.768 0 1.251 1.251 0 000-1.768l-3.722-3.722a.25.25 0 010-.354l3.72-3.722a1.25 1.25 0 000-1.767z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm0 22a10 10 0 1110-10 10.011 10.011 0 01-10 10z"
  })));
}
export default SvgCloseRound;